import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/image/logo/trust_fund_title.svg'


const _hoisted_1 = { class: "full-layout-header-mobile-view" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header-right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_more_vector = _resolveComponent("more-vector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "previous-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.go(-1)))
    }, [
      _createVNode(_component_more_vector, { fill: "#000000" })
    ]),
    _createElementVNode("img", {
      src: _imports_0,
      alt: "title",
      class: "header-logo pointer-hover",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push({ name: 'home' })))
    }),
    _hoisted_2
  ]))
}